import React, { useEffect, useState } from 'react';
import { Grid, Paper, Dialog, Typography, withStyles } from '@material-ui/core';
import { getDownloadButtons, checkAvailableKeys, checkIfAvailable, alternativeDownloads, styles } from './DownloadPage';
import { snackActions } from '../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../sc-utilities';
import AppLogoLoading from '../sc-logo';
import { connect } from 'react-redux';

const downloadButtons = (translations) => [
    { downloadKey: 'command', name: translations['command_download'] || 'PC ISO' },
];

const Command = (props) => {
    const { classes, translations, permissions, activeCustomerID } = props;
    const icon = (
        <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#7485FF"
                d="M12.33,1.22V4.06H6.84l.09-2.84h-6L.84,4.06l-.19,6L.22,23.2,0,30l5.89,3.46L15.33,39l2.93-1.71,0,0V1.22Zm0,29.1L6.11,26.66l.54-16.6h5.69Z"
            />
            <path
                fill="#7485FF"
                d="M30.44,23.2,30,10.06l-.19-6-.09-2.84h-6l.1,2.84H21.27v6H24l.54,16.6-3.29,1.93v7l3.51-2.06L30.67,30Z"
            />
        </svg>
    );
    const [availableKeys, setAvailableKeys] = useState();
    const [privateAvailableKeys, setPrivateAvailableKeys] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchKeys = async () => {
            const res = await checkAvailableKeys(activeCustomerID).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            const privateRes = await checkAvailableKeys(activeCustomerID, false).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            if (res?.status === 200 && privateRes?.status === 200) {
                setAvailableKeys(res.data.result.data);
                setPrivateAvailableKeys(privateRes.data.result.data);
            }
            setLoading(false);
        };
        fetchKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translations]);

    return (
        <Paper className={classes.root}>
            {hasPermission(permissions, 'binary_image_download') && (
                <>
                    <div className={classes.customToolbar}>
                        <div className={classes.tableTitle}>
                            {BackButton(translations, classes.customTooltip)}
                            <Typography className={classes.typography}>
                                {translations['downloads'] || 'Downloads'}
                            </Typography>
                        </div>
                    </div>
                    {!loading && (
                        <>
                            <Grid container direction="row" className={classes.grid}>
                                <Grid item ms={12} lg={6}>
                                    <h2>
                                        {icon} Command{' '}
                                        <span className={classes.latestVersionSpan}>
                                            - {translations['latest_version'] || 'Latest Version'}
                                        </span>
                                    </h2>
                                    <p>
                                        {translations['command_download_page'] ||
                                            'Deployment of Work images & label printing server.'}
                                    </p>
                                </Grid>
                                <Grid item ms={6} lg={6} container direction="row" justify="center" alignItems="center">
                                    {getDownloadButtons(
                                        downloadButtons(translations),
                                        availableKeys,
                                        classes,
                                        privateAvailableKeys
                                    )}
                                    {checkIfAvailable(
                                        availableKeys,
                                        downloadButtons(translations),
                                        alternativeDownloads,
                                        classes,
                                        translations,
                                        privateAvailableKeys
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        open={loading}
                        PaperProps={{
                            classes: {
                                root: classes.loadingScreen,
                            },
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Command));
